const SaudiRyal = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="32"
      viewBox="0 0 29 32"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_279_9480)">
        <path
          d="M18.0485 28.3484C17.531 29.4813 17.1889 30.7108 17.0579 32L28.0092 29.7017C28.5267 28.569 28.8685 27.3393 28.9998 26.05L18.0485 28.3484Z"
          fill="#231F20"
        />
        <path
          d="M28.0091 22.8158C28.5266 21.6832 28.8687 20.4535 28.9998 19.1642L20.469 20.9555V17.512L28.0089 15.9301C28.5264 14.7974 28.8684 13.5678 28.9995 12.2785L20.4688 14.0682V1.68432C19.1616 2.40893 18.0007 3.37347 17.0571 4.51121V14.7845L13.6453 15.5004V0C12.3382 0.724361 11.1773 1.68916 10.2336 2.82689V16.2161L2.59989 17.8177C2.08239 18.9503 1.74005 20.18 1.60875 21.4693L10.2336 19.6596V23.9961L0.99038 25.9354C0.472882 27.068 0.130807 28.2977 -0.000244141 29.587L9.67485 27.557C10.4624 27.3953 11.1394 26.9356 11.5795 26.3029L13.3538 23.7058V23.7052C13.538 23.4365 13.6453 23.1126 13.6453 22.7636V18.9437L17.0571 18.2277V25.1147L28.0089 22.8153L28.0091 22.8158Z"
          fill="#231F20"
        />
      </g>
      <defs>
        <clipPath id="clip0_279_9480">
          <rect width="29" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SaudiRyal;
